// Staging's one-time session hand-back (public/index.html; the fullstack's
// shared/clerkSessionSync.js): the fullstack sent the browser here as "#clerk-sync&return=<its
// URL>"; once Clerk has loaded, back there with this site's session (buildUrlWithAuth). After
// 8 s without Clerk, back anyway. Only a return to the partner staging site is followed.
const PARTNER_HOSTS = {
  "staging.vizbi.org": "fullstack-staging.vizbi.org",
  "fullstack-staging.vizbi.org": "staging.vizbi.org"
};

function getSyncReturn() {
  const match = window.location.hash.match(/^#clerk-sync&return=(.+)$/);
  if (!match) return "";
  try {
    const url = new URL(decodeURIComponent(match[1]));
    return url.hostname === PARTNER_HOSTS[window.location.hostname] ? url.href : "";
  } catch {
    return "";
  }
}

async function waitForClerk(timeoutMs = 8000) {
  const start = Date.now();
  while (!window.Clerk?.loaded && Date.now() - start < timeoutMs) {
    await new Promise((resolve) => setTimeout(resolve, 100));
  }
  return window.Clerk;
}

export async function handleClerkSync() {
  const returnUrl = getSyncReturn();
  if (!returnUrl) return;
  const clerk = await waitForClerk();
  window.location.replace(clerk?.buildUrlWithAuth?.(returnUrl) || returnUrl);
}
